import Display from './Display';
import TemplateType from './TemplateType';
import Name from './Name';
import Select from './Select';
import NameCheck from './NameCheck';
import InputNumber from './InputNumber';
import Tree from './Tree';
import Grid from './Grid';
import IntegerSlider from './IntegerSlider';
import SelectInput from './SelectInput2';
import TermName from './TermName';
import Multiple from './Multiple';
import GridMul from './GridMul';
import TargetTree from './TargetTree';

export default {
    GridMul,
    Display,
    TemplateType,
    Name,
    Select,
    NameCheck,
    InputNumber,
    Tree,
    Grid,
    IntegerSlider,
    SelectInput,
    TermName,
    Multiple,
    TargetTree
}